import { Outlet, createFileRoute, useParams } from '@tanstack/react-router';

import { CourseDetailPage } from '@/views/admin/courses/course-detail-page.tsx';

// 课程详情布局路由。`courses_` 段选择不在 /admin/courses 列表（无 <Outlet/>）
// 下嵌套，因此在 /admin shell 下独立渲染，提供 tab shell + 自身的 <Outlet/>
// 给 13 个 tab 子路由（info / curriculum / homeworks / quizzes / assessments /
// questions / gradebook / rubrics / awards / attendance / enrollments / teachers /
// settings）。`id === 'new'` 为创建流程。
export const Route = createFileRoute('/admin/courses_/$id')({
  component: CourseDetailRoute,
});

function CourseDetailRoute() {
  const { id } = useParams({ from: '/admin/courses_/$id' });
  return (
    <CourseDetailPage id={id}>
      <Outlet />
    </CourseDetailPage>
  );
}
